/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React, { Fragment, useRef } from "react";
import icon_trash from "designs/images/icon_trash.svg";
import type { UserMessage } from "@spwn/types/firebase/firestore";
import { withNoTranslate } from "i18n/noTranslate";
import { StreamingCommentBanDialog } from "containers/streaming/StreamingCommentBanDialog";
import { useIsChatAdmin } from "containers/streaming/useIsChatAdmin";
import { useDisclosure } from "hooks/useDisclosure";

interface Props {
  eventId: string;
  message: UserMessage;
  isCommentUser: boolean;
  isDarkModeEnabled: boolean;
  onClickBanUser: (comment: Pick<UserMessage, "_id" | "uid">) => Promise<void>;
  onClickBanComment: (idx: string) => Promise<void>;
  msgDeleteFunction: (idx: string) => void;
}
export const CommentItemNormal: React.FC<Props> = (props) => {
  const isChatAdmin = useIsChatAdmin(props.eventId);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const ref = useRef<HTMLDivElement>(null);

  const chatClasses = chatDesign({
    isChatAdmin,
    isDarkModeEnabled: props.isDarkModeEnabled,
  });

  return (
    <Fragment>
      {isChatAdmin && !props.isCommentUser && (
        <StreamingCommentBanDialog
          target={ref}
          banTargetComment={isOpen ? props.message : undefined}
          disableUserBlock={props.isCommentUser}
          onClose={onClose}
          onClickBanUser={props.onClickBanUser}
          onClickBanComment={props.onClickBanComment}
        />
      )}
      <div ref={ref} css={chatClasses.chat} onClick={onOpen}>
        <div css={chatClasses.chatIcon}>
          <img
            src={props.message.icon}
            alt={props.message.name}
            className="icon"
          />
        </div>
        <div css={chatClasses.chatInfo}>
          <p {...withNoTranslate()}>
            <span className="name">{props.message.name}</span>
            {props.message.msg}
          </p>
          {props.isCommentUser && (
            // コメント削除ボタンを表示する
            <img
              src={icon_trash}
              alt=""
              className="msg_menu"
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              onClick={() => props.msgDeleteFunction(props.message._id!)}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

type ChatDesignProps = {
  isChatAdmin: boolean;
  isDarkModeEnabled: boolean;
};
const chatDesign = (props: ChatDesignProps) => {
  const textColorInDarkMode = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;
  return {
    chat: css`
      display: flex;
      position: relative;
      padding: 0px 5px;
      margin-bottom: 8px;
      ${props.isChatAdmin
        ? `
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }`
        : undefined}
    `,
    chatIcon: css`
      width: 30px;
      margin-right: 10px;
      img {
        width: 30px;
        height: 30px;
        background-color: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 50%;
        object-fit: cover;
      }
    `,
    chatInfo: css`
      width: calc(100% - 40px);
      padding: 5px 20px 0 0;
      line-height: 1em;
      p {
        ${textColorInDarkMode}
        font-size: 12px;
        line-height: 1.5em;
        word-wrap: break-word;
        span {
          margin-right: 8px;
          font-weight: bold;
        }
      }
      img {
        position: absolute;
        top: 50%;
        right: 5px;
        width: 13px;
        height: 13px;
        margin-top: -6px;
        cursor: pointer;
      }
    `,
  };
};
